<i [attr.width]="width" [attr.height]="height" [attr.data-feather]="icon"></i>
